<template>
	<div id="holoverz-screen">
		<jumbotron :logoSrc="'/images/logos/holoverz-logo-full.svg'"
			:description="$t('holoverzScreen.welcome.description')"
			:textColor="'rgba(38, 42, 82, 1)'"
			:backgroundImage="'/images/sections/holoverz/desktop/holoverz_header.png'"
			:mobileBackgroundImage="'/images/sections/holoverz/mobile/holoverz_header.png'">
			<template v-slot:chart>
				<chart-component v-if="refactoredData" :titleText="$t('holoverzScreen.welcome.chart.title')"
					:subtitleText="$t('holoverzScreen.welcome.chart.subtitle', {
						value: calculatedLastPrice,
					})
						" :infoText="$t('holoverzScreen.welcome.chart.infoText')" :chart-data="refactoredData"
					:gradientStartColor="'rgba(247, 87, 215, 0.2)'" :gradientEndColor="'rgba(247, 87, 215, 0)'"
					:infoTooltipBackground="'#4B2EAA'" />
			</template>
		</jumbotron>
		<holoverz-white-paper :text="$t('holoverzScreen.whitepaper.text')"
			:buttonText="$t('holoverzScreen.whitepaper.button')"
			:buttonLink="'https://data.blockben.com/whitepaper/holoverz.pdf'" />
		<!-- <div id="holoverz-collection">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-6 col-12 d-flex d-md-flex justify-content-center">
						<img
							class="wallet-image d-none d-md-block"
							src="/images/sections/holoverz/desktop/holoverz_card.png"
						/>
					</div>
					<div class="col-md-6 col-12">
						<div class="title headline-l">
							{{ $t('holoverzScreen.collection.title') }}
						</div>
						<img
							class="main-image d-block d-md-none"
							src="/images/sections/holoverz/mobile/holoverz_card.png"
						/>
						<div class="text text-l mt-4">
							{{ $t('holoverzScreen.collection.description') }}
						</div>
						<base-button
							class="more-button mt-4"
							:text="$t('holoverzScreen.collection.btn')"
							size="small"
							type="primary"
							@clicked="handleCardButtonClick()"
						/>
					</div>
				</div>
			</div>
		</div> -->
		<advantages-section :backgroundColor="'#fff'" :advantagesTitle="$t('holoverzScreen.advantages.title')"
			:advantages="holoverzAdvantages" />
		<div id="payment">
			<div class="bg">
				<div class="content">
					<h1>{{ $t('holoverzScreen.payment.title') }}</h1>
					<h2>{{ $t('holoverzScreen.payment.subtitle') }}</h2>
					<p>{{ $t('holoverzScreen.payment.description') }}</p>
					<p>{{ $t('holoverzScreen.payment.description_2') }}</p>
				</div>
			</div>
		</div>
		<div id="exchange_rate">
			<div class="container d-none d-md-flex">
				<div class="img_container col-5">
					<img src="/images/sections/holoverz/desktop/increasing_exchange_rate.png" />
				</div>
				<div class="content col-7">
					<h1>{{ $t('holoverzScreen.exchange_rate.title') }}</h1>
					<h2>{{ $t('holoverzScreen.exchange_rate.subtitle') }}</h2>
					<p class="mt-1">
						{{ $t('holoverzScreen.exchange_rate.description_1') }}
					</p>
					<p class="mt-4">
						{{ $t('holoverzScreen.exchange_rate.description_2') }}
					</p>
					<p class="mt-4" v-html="$t('holoverzScreen.exchange_rate.description_3')"></p>
				</div>
			</div>
			<div class="d-block d-md-none text-center">
				<h1 class="m-auto">{{ $t('holoverzScreen.exchange_rate.title') }}</h1>
				<div class="img_container mt-4">
					<img src="/images/sections/holoverz/mobile/increasing_exchange_rate.png" class="w-100" />
				</div>
				<div class="content px-3">
					<h2>{{ $t('holoverzScreen.exchange_rate.subtitle') }}</h2>
					<h2>{{ $t('holoverzScreen.exchange_rate.description_1') }}</h2>
					<p>{{ $t('holoverzScreen.exchange_rate.description_2') }}</p>
					<p class="mt-4">
						{{ $t('holoverzScreen.exchange_rate.description_3') }}
					</p>
				</div>
			</div>
		</div>
		<details-section :backgroundColor="'#fff'" :boxOptions="boxOptions"
			:faqTitle="$t('holoverzScreen.details.faq.title')" :faq="faq" />
		<details-section class="fees-section" :backgroundColor="'#fff'" :boxOptions="boxOptions"
			:feesTitle="$t('holoverzScreen.details.fees.title')" :fees="fees" />
		<details-section class="limits-section" :backgroundColor="'#fff'" :boxOptions="boxOptions"
			:limitationsTitle="$t('holoverzScreen.details.limitations.title')" :limitations="limitations" />
		<div id="about" class="container">
			<h1>{{ $t('holoverzScreen.about.title') }}</h1>
			<div class="info_box_container mt-5">
				<!-- <div class="info_box">
					<h2>{{ $t('holoverzScreen.about.first.title') }}</h2>
					<p v-html="$t('holoverzScreen.about.first.description')" />
				</div> -->
				<div class="info_box">
					<h2>{{ $t('holoverzScreen.about.second.title') }}</h2>
					<p v-html="$t('holoverzScreen.about.second.description')" />
				</div>
				<div class="info_box">
					<h2>{{ $t('holoverzScreen.about.third.title') }}</h2>
					<p v-html="$t('holoverzScreen.about.third.description')" />
				</div>
			</div>
		</div>
		<div id="download">
			<div class="bg">
				<div class="content">
					<img src="/images/logos/holoverz-logo-full.svg" />
					<base-button :text="$t('holoverzScreen.download.paperButtonText')" size="large"
						@clicked="handleButtonClick()" />
				</div>
			</div>
		</div>
		<!--  Collector Collections  -->
		<div id="holoverz-collection-screen">
			<div class="top-img-container">
				<div class="shadow">
					<img src="/images/screens/collections/desktop/holox_top_img_shadow.png" class="d-none d-lg-block"
						style="width: 100%" />
					<img src="/images/screens/collections/mobile/holox_top_img_shadow.png"
						class="d-lg-none d-xs-block d-sm-block" style="width: 100%" />
				</div>
				<div class="text-section text-center">
					<div class="title headline-l">
						{{ $t('holoverzCollectionsScreen.title') }}
					</div>
					<div class="sub mt-3">
						{{ $t('holoverzCollectionsScreen.description_1') }}
					</div>
				</div>
				<div class="button-container">
					<base-button class="button" :text="$t('holoverzCollectionsScreen.goToHoloxButton')"
						@clicked="goToHoloxBoxes()" />
				</div>
				<img src="/images/screens/collections/desktop/holox_top.png" class="d-none d-lg-block"
					style="width: 100%" />
				<img src="/images/screens/collections/mobile/holox_top.png"
					class="mobile-img d-lg-none d-xs-block d-sm-block" />
			</div>
			<div class="advantages-container">
				<div v-for="(advantage, i) in advantages" :key="i" class="advantage py-5">
					<img class="img" :src="advantage.img" />
					<div class="title">{{ $t(advantage.title) }}</div>
				</div>
			</div>
			<div id="holox-boxes" class="boxes-container">
				<div class="title mb-2">
					{{ $t('holoverzCollectionsScreen.holoxBoxes.title') }}
				</div>
				<!-- <div class="boxes" :style="!needCarousel ? 'display: flex' : 'display: none'"> -->
				<div class="boxes d-none d-md-flex">
					<div v-for="(box, i) in holoxBoxes" :key="i" class="holox-box">
						<img class="img" :src="box.img" />
						<div class="title">{{ $t(box.title) }}</div>
						<div class="description" v-html="$t(box.description)"></div>
						<div class="price">{{ $t(box.price) }}</div>
						<!-- <div class="button-container">
							<base-button
								class="button"
								:text="
									$t('holoverzCollectionsScreen.holoxBoxes.boxes.buyNowButton')
								"
								@clicked="goToHowToBuy()"
							/>
						</div> -->
					</div>
				</div>
				<!-- <div :style="needCarousel ? 'display: block' : 'display: none'"> -->
				<div class="d-md-none d-xs-block d-sm-block">
					<carousel class="boxes" ref="carousel" :loop="true" :autoplay="false" :margin="75" :nav="true"
						:navText="navTextCarousel" :dots="true" :items="holoxBoxes.length" :rewind="false"
						:autoplayHoverPause="false" :slideTransition="'linear'" :touchDrag="false"
						:responsive="carouselConfig">
						<div v-for="(box, i) in holoxBoxes" :key="i" class="holox-box py-5">
							<img class="img" :src="box.img" />
							<div class="title">{{ $t(box.title) }}</div>
							<div class="description" v-html="$t(box.description)"></div>
							<div class="price">{{ $t(box.price) }}</div>
							<div class="button-container">
								<base-button class="button" :text="$t(
									'holoverzCollectionsScreen.holoxBoxes.boxes.buyNowButton',
								)
									" @clicked="goToHowToBuy()" />
							</div>
						</div>
					</carousel>
				</div>
			</div>
			<div class="voucher-faq-container">
				<div class="title">
					{{ $t('holoverzCollectionsScreen.voucherFaq.title') }}
				</div>
				<div class="description">
					{{ $t('holoverzCollectionsScreen.voucherFaq.description') }}
				</div>
				<div class="button-container">
					<base-button class="button" :text="$t('holoverzCollectionsScreen.voucherFaq.buttonText')"
						@clicked="goToVoucherFaq()" />
				</div>
			</div>
		</div>
		<warning-section :firstDescription="$t('holoverzScreen.warningSection.firstDescription')"
			:secondDescription="$t('holoverzScreen.warningSection.secondDescription')" />
		<!-- <other-products :hiddenProductKey="'bit'" /> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/api';
import moment from 'moment';
import carousel from 'vue-owl-carousel';
import Jumbotron from '../../components/elements/Jumbotron.vue';
import AdvantagesSection from '@/components/sections/bit/AdvantagesSection';
import DetailsSection from '@/components/sections/bit/DetailsSection';
import ReportSection from '@/components/sections/bit/ReportSection';
import BitFamilySection from '@/components/sections/bit/BitFamilySection';
import WarningSection from '@/components/sections/bit/WarningSection';
import OtherProducts from '@/components/sections/OtherProducts';
import ChartComponent from '@/components/elements/ChartComponent';
import HoloverzWhitePaper from '@/components/sections/holoverz/HoloverzWhitePaper';

export default {
	name: 'HoloverzScreen',
	components: {
		Jumbotron,
		AdvantagesSection,
		DetailsSection,
		ReportSection,
		BitFamilySection,
		WarningSection,
		OtherProducts,
		ChartComponent,
		carousel,
		HoloverzWhitePaper,
	},
	data: () => ({
		chartDataLimit: 7,
		chartDataInterval: '1m',
		chartData: undefined,
		holoverzAdvantages: [
			{
				iconUrl: '/images/icons/inimitable.svg',
				labelKey: 'holoverzScreen.advantages.labels.inimitable',
				descriptionKey: 'holoverzScreen.advantages.descriptions.inimitable',
			},
			{
				iconUrl: '/images/icons/dynamic.svg',
				labelKey: 'holoverzScreen.advantages.labels.dynamic',
				descriptionKey: 'holoverzScreen.advantages.descriptions.dynamic',
			},
			{
				iconUrl: '/images/icons/information_storage.svg',
				labelKey: 'holoverzScreen.advantages.labels.informationStorage',
				descriptionKey:
					'holoverzScreen.advantages.descriptions.informationStorage',
			},
			{
				iconUrl: '/images/icons/quality.svg',
				labelKey: 'holoverzScreen.advantages.labels.quality',
				descriptionKey: 'holoverzScreen.advantages.descriptions.quality',
			},
			{
				iconUrl: '/images/icons/colorful.svg',
				labelKey: 'holoverzScreen.advantages.labels.colorful',
				descriptionKey: 'holoverzScreen.advantages.descriptions.colorful',
			},
			{
				iconUrl: '/images/icons/licensed.svg',
				labelKey: 'holoverzScreen.advantages.labels.licensed',
				descriptionKey: 'holoverzScreen.advantages.descriptions.licensed',
			},
			{
				iconUrl: '/images/icons/one_of_a_kind.svg',
				labelKey: 'holoverzScreen.advantages.labels.oneOfAKind',
				descriptionKey: 'holoverzScreen.advantages.descriptions.oneOfAKind',
			},
			{
				iconUrl: '/images/icons/flexible.svg',
				labelKey: 'holoverzScreen.advantages.labels.flexible',
				descriptionKey: 'holoverzScreen.advantages.descriptions.flexible',
			},
		],
		boxOptions: {
			borderColor: 'rgba(123, 208, 255, 1)',
			borderWidth: 15,
			boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
			hasBorderAround: false,
			background:
				'linear-gradient(111.11deg, #FFFFFF -3.09%, #FEFEFE 53.29%, #F7F7F7 103.03%)',
		},
		faq: [
			{
				title: 'holoverzScreen.details.faq.parts.first.value',
				values: [
					{
						value: '',
						label: 'holoverzScreen.details.faq.parts.first.description',
					},
				],
			},
			{
				title: 'holoverzScreen.details.faq.parts.second.value',
				values: [
					{
						value: '',
						label: 'holoverzScreen.details.faq.parts.second.description',
					},
				],
			},
		],
		fees: [
			{
				title: 'holoverzScreen.details.fees.parts.buying.title',
				values: [
					{
						value: '',
						label: 'holoverzScreen.details.fees.parts.buying.list.first.label',
					},
				],
			},
			{
				title: 'holoverzScreen.details.fees.parts.transfer.title',
				values: [
					{
						value: '',
						label:
							'holoverzScreen.details.fees.parts.transfer.list.first.label',
					},
				],
			},
			{
				title: 'holoverzScreen.details.fees.parts.sell.title',
				values: [
					{
						value: '',
						label: 'holoverzScreen.details.fees.parts.sell.list.first.label',
					},
				],
			},
			{
				title: 'holoverzScreen.details.fees.parts.pay.title',
				values: [
					{
						value: '',
						label: 'holoverzScreen.details.fees.parts.pay.list.first.label',
					},
				],
			},
		],
		limitations: [
			{
				title: 'holoverzScreen.details.limitations.parts.first.title',
				values: [
					{
						value: '',
						label:
							'holoverzScreen.details.limitations.parts.first.list.first.label',
					},
				],
			},
		],
		advantages: [
			{
				title: 'holoverzCollectionsScreen.advantages.inimitable',
				img: '/images/screens/collections/inimitable.svg',
			},
			{
				title: 'holoverzCollectionsScreen.advantages.unremakeable',
				img: '/images/screens/collections/unremakeable.svg',
			},
			{
				title: 'holoverzCollectionsScreen.advantages.unique',
				img: '/images/screens/collections/totally_unique.svg',
			},
		],
		holoxBoxes: [
			{
				img: '/images/screens/collections/holox_yellow.png',
				title: 'holoverzCollectionsScreen.holoxBoxes.boxes.yellow.title',
				description:
					'holoverzCollectionsScreen.holoxBoxes.boxes.yellow.description',
				price: 'holoverzCollectionsScreen.holoxBoxes.boxes.yellow.price',
			},
			{
				img: '/images/screens/collections/holox_silver.png',
				title: 'holoverzCollectionsScreen.holoxBoxes.boxes.silver.title',
				description:
					'holoverzCollectionsScreen.holoxBoxes.boxes.silver.description',
				price: 'holoverzCollectionsScreen.holoxBoxes.boxes.silver.price',
			},
			{
				img: '/images/screens/collections/holox_black.png',
				title: 'holoverzCollectionsScreen.holoxBoxes.boxes.black.title',
				description:
					'holoverzCollectionsScreen.holoxBoxes.boxes.black.description',
				price: 'holoverzCollectionsScreen.holoxBoxes.boxes.black.price',
			},
			{
				img: '/images/screens/collections/holox_diamond.png',
				title: 'holoverzCollectionsScreen.holoxBoxes.boxes.diamond.title',
				description:
					'holoverzCollectionsScreen.holoxBoxes.boxes.diamond.description',
				price: 'holoverzCollectionsScreen.holoxBoxes.boxes.diamond.price',
			},
		],
		carouselConfig: {
			0: {
				items: 1,
			},
			992: {
				items: 1,
			},
			1400: {
				items: 1,
			},
		},
		navTextCarousel: [
			'<img src="/images/screens/collections/arrow-left.svg"/>',
			'<img src="/images/screens/collections/arrow-right.svg"/>',
		],
	}),
	computed: {
		...mapGetters({
			getSelectedLanguage: 'settings/getSelectedLanguage',
		}),
		calculatedLastPrice() {
			if (this.chartData) {
				return this.chartData[this.chartData.length - 1].rate.toFixed(2);
			}
			return undefined;
		},
		refactoredData() {
			if (this.chartData) {
				return {
					labels: this.chartData.map((obj) => {
						moment.locale(this.getSelectedLanguage);
						const newDate = moment(new Date(obj.date))
							.format('MMM')
							.replace('.', '');
						return newDate.toLowerCase();
					}),
					tooltipLabel: (value) => `€${value.yLabel.toFixed(2)} / Holoverz`,
					datasets: [
						{
							data: this.chartData.map((obj) => obj.rate),
							borderColor: 'rgba(247, 87, 215, 1)',
							pointBackgroundColor: 'rgba(255, 255, 255, 1)',
							pointBorderColor: 'rgba(75, 46, 170, 1)',
							borderCapStyle: 'round',
							pointHoverBackgroundColor: '#fff',
							pointHoverBorderColor: 'rgba(75, 46, 170, 1)',
							pointHighlightFill: '#fff',
							pointHoverBorderWidth: 2,
							backgroundColor: 'transparent',
							pointColor: '#fff',
							pointStrokeColor: '#242A55',
						},
					],
				};
			}
			return undefined;
		},
	},
	async mounted() {
		const response = await Api.get(
			`publicReferencePrice/3DHT?limit=${this.chartDataLimit}&interval=${this.chartDataInterval}`,
		);
		this.chartData = await response.json();

		const res = await Api.get('publicPrice');
		this.currentPrice = await res.json();

		let currentProduct = this.currentPrice.find((price) => {
			return price.asset === '3DHT' && price.type === 'Buy';
		});

		if (currentProduct) {
			this.chartData[this.chartData.length - 1].rate = currentProduct.rate;
		}
	},
	methods: {
		handleButtonClick() {
			if (this.$i18n.locale === 'hu') {
				window.open(
					'https://data.blockben.com/whitepaper/Holoverz_Lightpaper_HU.pdf',
					'_blank',
				);
			} else {
				window.open(
					'https://data.blockben.com/whitepaper/Holoverz_Lightpaper_EN.pdf',
					'_blank',
				);
			}
		},
		handleCardButtonClick() {
			this.$router.push({ path: '/holoverz-collections' });
		},
		goToHoloxBoxes() {
			const holoxBoxes = document.getElementById('holox-boxes');
			window.scrollTo({
				top: holoxBoxes.offsetTop - 80,
				behavior: 'smooth',
			});
		},
		goToHowToBuy() {
			const infoSection = document.getElementById('info-section');
			console.log("infoSection", infoSection);
			window.scrollTo({
				top: infoSection.offsetTop - 80,
				behavior: 'smooth',
			});
		},
		goToWallet() {
			window.open('https://holoverz.shop/');
		},
		goToVoucherFaq() {
			window.open('https://data.blockben.com/faq/holox_voucher_eng.pdf');
		},
	},
};
</script>

<style lang="scss" scoped>
.jumbotron {
	&.has-bgimage {
		@media (max-width: $breakpoint-xs) {
			background-position: center center;
		}
	}

	&::v-deep {
		.jumbotron-container {
			height: 655px;
		}

		.jumbotron-row {
			@media (max-width: $breakpoint-sm) {
				height: 100% !important;
			}
		}

		.top-section {
			padding: 0;
		}

		.description {
			margin: 25px 0 40px;
		}

		.stores-label {
			text-decoration: underline;
		}
	}
}

.reports-section {
	margin: 190px 0 0;
}

.advantages-section {
	margin: 70px 0 30px 0;
	padding: 0;
}

.details-section {
	&:not(.limits-section) {
		&::v-deep {
			.fees {
				padding: 0;
			}
		}
	}

	&::v-deep {
		section.division {
			.bordered-box {
				padding-right: 55px;
			}
		}
	}
}

.fees-section {
	padding: 60px 0;
}

@media (max-width: 768px) {
	.bitFamily-section {
		padding-top: 100px;
	}
}

.limits-section {
	padding: 60px 0 0;

	&::v-deep {
		.division {
			padding: 0;
		}

		.informations-wrapper {
			.info-text {
				max-width: 800px;
			}
		}

		.description-wrapper {
			li .label .prefix {
				display: none;
			}
		}
	}
}


.other-products {
	&::v-deep {
		.products-wrapper {
			padding: 0;
			column-gap: 30px;
		}
	}
}

@media (max-width: $breakpoint-sm) {
	#chart-component {
		box-shadow: 0px 4px 8px rgba(36, 42, 85, 0.1);
		z-index: 1;
	}
}

.introduction-section {
	@media (max-width: $breakpoint-sm) {
		padding-top: 0;

		&::v-deep {
			.illustration {
				width: 100%;
				height: auto;
			}

			.content-col {
				padding-top: 30px;
			}
		}
	}
}

.details-section {
	&::v-deep {
		.section-title {
			@media (max-width: $breakpoint-sm) {
				margin: 0 0 45px;
				text-align: left;
				padding-left: 0;
			}
		}
	}
}

#payment {
	color: rgba(38, 42, 82, 1);
	text-align: center;

	.bg {
		background-image: url('/images/sections/holoverz/desktop/new_payment.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		padding: 60px 0;

		@media (max-width: $breakpoint-xs) {
			background-image: url('/images/sections/holoverz/mobile/new_payment.png');
		}
	}

	.content {
		max-width: 1000px;
		margin: auto;
		padding: 0 30px;
	}

	h1 {
		font-size: 40px;
		line-height: 52px;
		font-family: 'HKNova-Bold', sans-serif;
		margin-bottom: 40px;
	}

	p {
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		max-width: 790px;
		margin: 20px auto 0 auto;
	}

	h2 {
		font-weight: 700;
		font-size: 16px;
		line-height: 24px;
	}
}

#exchange_rate {
	margin: 100px 0;

	@media (max-width: $breakpoint-xs) {
		margin: 32px 0;
	}

	h1 {
		font-size: 40px;
		line-height: 52px;
		font-family: 'HKNova-Bold', sans-serif;
		color: rgba(38, 42, 82, 1);
		max-width: 450px;
	}

	h2 {
		font-size: 16px;
		line-height: 30px;
		font-weight: 700;
		color: rgba(70, 102, 143, 1);
		margin-top: 30px;
	}

	p {
		font-size: 16px;
		font-weight: 400;
		line-height: 30px;
		color: rgba(70, 102, 143, 1);
	}

	img {
		height: 100%;
		object-fit: cover;
	}
}

#about {
	margin-bottom: 80px;

	h1 {
		color: rgba(38, 42, 82, 1);
		font-size: 40px;
		line-height: 52px;
		font-family: 'HKNova-Bold', sans-serif;
	}

	h2 {
		color: rgba(70, 102, 143, 1);
		font-size: 18px;
		line-height: 24px;
		font-weight: 700;
		margin-bottom: 32px;
	}

	P {
		color: rgba(70, 102, 143, 1);
		font-size: 16px;
		line-height: 24px;
		font-weight: 400;
	}

	.info_box_container {
		display: flex;
		gap: 30px;
		justify-content: center;

		@media screen and (max-width: $breakpoint-sm) {
			flex-wrap: wrap;
		}
	}

	.info_box {
		box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(246, 244, 255, 1);
		padding: 40px 20px;
	}
}

#holoverz-collection {
	margin: 100px 0;

	@media (max-width: 768px) {
		margin: 50px 0;
		text-align: center;

		img {
			margin: 30px auto 0 auto;
		}
	}
}

#download {
	.bg {
		background-image: url('/images/sections/holoverz/desktop/download.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		padding: 60px 0;

		@media (max-width: $breakpoint-xs) {
			background-image: url('/images/sections/holoverz/mobile/download.png');
		}
	}

	.content {
		padding: 60px 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 40px;
		color: rgba(255, 255, 255, 1);
		max-width: 730px;
		margin: auto;
		text-align: center;

		h1 {
			font-size: 30px;
			line-height: 40px;
			color: #fff;
			font-weight: 700;
		}
	}
}

#buy {
	margin-top: 80px;

	h1 {
		color: rgba(38, 42, 82, 1);
		font-size: 40px;
		line-height: 52px;
		font-family: 'HKNova-Bold', sans-serif;
		margin-bottom: 20px;
	}

	.box {
		display: flex;
		border-radius: 8px;
		align-items: center;
		gap: 30px;
		width: 540px;
		border: 1px solid rgba(246, 244, 255, 1);
		margin-top: 30px;

		.description {
			font-size: 16px;
			line-height: 24px;
			font-weight: 400;
			color: rgba(70, 102, 143, 1);
			max-width: 70%;
		}

		.step {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 95px;
			width: 65px;
			background-color: rgba(123, 208, 255, 1);
			border-radius: 8px 0 0 8px;

			p {
				color: rgba(70, 102, 143, 1);
				font-size: 25px;
				line-height: 45.5px;
				font-weight: 700px;
			}
		}
	}
}

// Collector Collections styles
.top-img-container {
	position: relative;
	background-color: #0f003f;

	.text-section {
		margin-top: 61px;
		position: absolute;
		width: 100%;

		.title {
			color: #01dba8;
		}

		.sub {
			font-size: 16px;
			color: #fff;
			font-weight: 400;
		}
	}

	.shadow {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 130px;
	}

	.button-container {
		position: absolute;
		bottom: 5%;
		left: 50%;
		transform: translate(-50%, -50%);

		button {
			font-family: 'HKNova-Bold', sans-serif !important;
			background-color: #01dba8;
			color: #17025c;
			width: 100%;
			height: 56px;
			font-size: 16px;
			font-weight: 700;
			line-height: 22px;
			text-transform: uppercase;

			&:hover {
				color: #fff;
				background: $link-hover-color;
			}
		}
	}

	@media (max-width: 1000px) {
		padding-top: 70px;
		margin-bottom: -1px;

		.mobile-img {
			padding-top: 160px;
			margin: 0 auto;
		}

		.text-section {
			margin-top: 0;
		}

		.button-container {
			width: 100%;
			padding: 0 10px;
			bottom: 0;
		}
	}
}

.advantages-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	min-height: 152px;
	background-color: #0f003f;
	border-top: 1px solid transparent;
	border-bottom: 1px solid transparent;
	border-image: linear-gradient(to right, transparent, #95c8f8, transparent) 1;
	padding: 0 166px;

	@media (max-width: 1000px) {
		border-top: 0;
		border-bottom: 1px solid transparent;
		border-image: linear-gradient(to right, transparent, #95c8f8, transparent) 1;
		flex-direction: row-reverse;
		padding: 0 18px;

		.advantage {
			padding: 0 24px;
		}
	}

	.advantage {
		.title {
			color: #d1d1d1;
			font-size: 16px;
			font-weight: 400;
			line-height: 30px;
			text-align: center;
		}

		.img {
			margin: 0 auto;
		}
	}
}

.boxes-container {
	min-height: 152px;
	background-color: #0f003f;
	padding: 65px 166px 75px;

	@media (max-width: 1097px) {
		padding: 65px 0 75px;
		display: flex;
		justify-content: space-around;
		flex-direction: column;
	}

	.title {
		color: #01dba8;
		font-size: 38px;
		font-weight: 700;
		line-height: 52px;
		text-align: center;
	}

	.boxes {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		position: relative;
		max-width: 790px;
		margin: 0 auto;
		margin-top: 60px;
		column-gap: 80px;
		row-gap: 60px;

		@media (max-width: 768px) {
			margin-top: 0px;
			column-gap: 0px !important;
			row-gap: 0px !important;
		}

		.holox-box {
			width: 355px;

			@media (max-width: 1097px) {}

			@media (max-width: 768px) {
				margin: 0 auto;
				margin-top: 35px;
				width: 80%;
				padding-bottom: 0px !important;
			}

			.img {
				border: 1px solid;
				border-color: rgba(203, 187, 255, 0.2);
				border-radius: 10px;
				margin-left: auto;
				margin-right: auto;
			}

			.title {
				font-family: 'HKNova-Bold', sans-serif !important;
				margin-top: 35px;
				font-size: 24px;
				font-weight: 700;
				line-height: 24px;
				text-align: center;
				color: #a3b6ec;
			}

			.description {
				margin-top: 35px;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
				text-align: left;
				color: #d1d1d1;
			}

			.price {
				margin-top: 30px;
				font-size: 24px;
				font-weight: 700;
				line-height: 24px;
				text-align: left;
				color: rgba(1, 219, 168, 1);
			}

			.button-container {
				margin-top: 35px;

				.button {
					font-family: 'HKNova-Bold', sans-serif !important;
					width: 100%;
					height: 54px;
					background-color: rgba(1, 219, 168, 1);
					font-size: 16px;
					font-weight: 700;
					line-height: 22px;
					color: #17025c;
					text-transform: uppercase;

					&:hover {
						color: #fff;
						background: $link-hover-color;
					}
				}
			}
		}

		&::v-deep {
			.owl-carousel {
				.owl-dots {
					position: absolute;
					top: 27px;
					left: 50%;
					transform: translateX(-50%);

					.owl-dot {
						span {
							background: rgba(149, 200, 248, 1);
						}

						&.active {
							span {
								background: rgba(1, 219, 168, 1);
								width: 12px;
								height: 12px;
							}
						}
					}
				}

				.owl-nav {
					.owl-prev {
						background: 0 !important;
						position: absolute;
						top: 50%;
						left: 0;
					}

					.owl-next {
						background: 0 !important;
						position: absolute;
						top: 50%;
						right: 0;
					}
				}
			}
		}
	}

	.stores-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 70px;
		gap: 40px;
		@media (max-width: $breakpoint-sm) {
			margin-top: 40px;
		}

		h1 {
			font-size: 30px;
			line-height: 40px;
			color: #fff;
			font-weight: 700;
			text-align: center;
		}
	}
}

.holox-info-container {
	background-color: #0f003f;
	padding: 56px 166px;
	border-top: 1px solid rgba(149, 200, 248, 1);

	@media (max-width: 768px) {
		padding: 40px 0px;
	}

	.title {
		font-size: 38px;
		font-weight: 700;
		line-height: 52px;
		text-align: center;
		color: rgba(1, 219, 168, 1);
		margin-bottom: 48px;
	}

	.infos-container {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		margin-top: 48px;
		max-width: 1112px;
		margin: 0 auto;

		.info {
			width: 350px;
			margin: 22px 8px;
			padding: 45px 32px;
			background: linear-gradient(-43.39deg, #0f003f 2.69%, #2f1b72 98.97%);
			border-radius: 10px;
			border: 1px solid rgba(203, 187, 255, 0.3);

			@media (max-width: 768px) {
				margin: 8px 0px;
				width: 80%;
			}

			.title-section {
				display: flex;
				align-items: center;

				@media (max-width: 768px) {
					flex-direction: column;

					.box-title {
						margin-left: 0 !important;
						margin-top: 25px;
					}
				}

				.img {
					height: 28px;
					width: 28px;
				}

				.box-title {
					margin-left: 24px;
					font-size: 18px;
					font-weight: 700;
					line-height: 24px;
					text-align: left;
					color: rgba(255, 255, 255, 1);
				}
			}

			.description {
				margin-top: 36px;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
				text-align: left;
				color: rgba(209, 209, 209, 1);

				&::v-deep {
					.highlight {
						font-size: 16px;
						font-weight: 700;
						line-height: 24px;
						text-align: left;
					}
				}
			}
		}
	}

	.footnote {
		font-size: 12px;
		font-weight: 400;
		line-height: 23px;
		text-align: left;
		color: rgba(209, 209, 209, 1);
		max-width: 1112px;
		margin: 0 auto;
		margin-top: 34px;

		@media (max-width: 768px) {
			display: flex;
			justify-content: space-around;
			padding: 0px 15px;
		}
	}

	.button-container {
		display: flex;
		justify-content: space-around;
		margin-top: 54px;

		@media (max-width: 768px) {
			padding: 0 10px;
		}

		button {
			font-family: 'HKNova-Bold', sans-serif !important;
			width: 350px;
			height: 54px;

			@media (max-width: 768px) {
				width: 100%;
			}

			background-color: #01dba8;
			color: #17025c;
			height: 56px;
			font-size: 16px;
			font-weight: 700;
			line-height: 22px;
			text-transform: uppercase;

			&:hover {
				color: #fff;
				background: $link-hover-color;
			}
		}
	}
}

.voucher-faq-container {
	background-color: #0f003f;
	padding: 56px 166px;
	border-top: 1px solid rgba(149, 200, 248, 1);
	text-align: center;

	@media (max-width: 768px) {
		padding: 40px 20px;
	}

	.title {
		font-size: 38px;
		font-weight: 700;
		line-height: 52px;
		color: rgba(1, 219, 168, 1);
		margin-bottom: 35px;
	}

	.description {
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		color: rgba(209, 209, 209, 1);
		margin-bottom: 40px;
	}

	.button-container {
		display: flex;
		justify-content: center;
		margin-bottom: 30px;

		button {
			font-family: 'HKNova-Bold', sans-serif !important;
			width: 350px;
			height: 56px;

			@media (max-width: 768px) {
				width: 100%;
			}

			background-color: #01dba8;
			color: #17025c;
			font-size: 16px;
			font-weight: 700;
			line-height: 22px;
			text-transform: uppercase;

			&:hover {
				color: #fff;
				background: $link-hover-color;
			}
		}
	}
}
</style>
